"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IncaVariableFormatters = exports.IncaVariableFunctionsLabels = exports.IncaVariableFunctions = exports.IncaVariables = void 0;
var types_1 = require("../types");
var types_2 = require("./types");
/**
 * inca variables available for usage on the platform.
 */
exports.IncaVariables = [
    {
        name: 'Single Choice Answers',
        type: types_2.INCA_VARIABLE_TYPES.SINGLE_CHOICE,
        supportedFunctionTypes: [
            types_2.INCA_VARIABLE_FUNCTION_TYPES.INCLUDES,
            types_2.INCA_VARIABLE_FUNCTION_TYPES.DOES_NOT_INCLUDE,
            types_2.INCA_VARIABLE_FUNCTION_TYPES.IS_DISPLAYED,
            types_2.INCA_VARIABLE_FUNCTION_TYPES.IS_NOT_DISPLAYED
        ],
        supportedFormatterTypes: [
            types_2.INCA_VARIABLE_FORMATTER_TYPES.TYPE_FORMAT,
            types_2.INCA_VARIABLE_FORMATTER_TYPES.TEXT_CASING,
            types_2.INCA_VARIABLE_FORMATTER_TYPES.TEXT_TO_DISPLAY,
            types_2.INCA_VARIABLE_FORMATTER_TYPES.OTHER_TEXT
        ],
        availableQTypes: [
            types_1.QTYPES.SINGLE_CHOICE,
            types_1.QTYPES.TREEMAN,
            types_1.QTYPES.SCALE,
            types_1.QTYPES.ICONS,
            types_1.QTYPES.VECTOR_MAP,
            types_1.QTYPES.POPUP_CARD,
            types_1.QTYPES.TRADE_OFF,
            types_1.QTYPES.NPS
        ]
    },
    {
        name: 'Unranked Multiple Choice Answers',
        type: types_2.INCA_VARIABLE_TYPES.MULTI_CHOICE,
        supportedFunctionTypes: [
            types_2.INCA_VARIABLE_FUNCTION_TYPES.INCLUDES,
            types_2.INCA_VARIABLE_FUNCTION_TYPES.DOES_NOT_INCLUDE,
            types_2.INCA_VARIABLE_FUNCTION_TYPES.OPT_NUM_GREATER_THAN,
            types_2.INCA_VARIABLE_FUNCTION_TYPES.OPT_NUM_EQUALS_TO,
            types_2.INCA_VARIABLE_FUNCTION_TYPES.OPT_NUM_LESS_THAN,
            types_2.INCA_VARIABLE_FUNCTION_TYPES.IS_DISPLAYED,
            types_2.INCA_VARIABLE_FUNCTION_TYPES.IS_NOT_DISPLAYED
        ],
        supportedFormatterTypes: [
            types_2.INCA_VARIABLE_FORMATTER_TYPES.TYPE_FORMAT,
            types_2.INCA_VARIABLE_FORMATTER_TYPES.TEXT_CASING,
            types_2.INCA_VARIABLE_FORMATTER_TYPES.TEXT_TO_DISPLAY,
            types_2.INCA_VARIABLE_FORMATTER_TYPES.OTHER_TEXT,
            types_2.INCA_VARIABLE_FORMATTER_TYPES.MULTI_OPTION_DISPLAY
        ],
        availableQTypes: [
            types_1.QTYPES.MULTIPLE_CHOICE,
            types_1.QTYPES.MULTI_POPUP_CARD,
            types_1.QTYPES.HOTSPOT,
            types_1.QTYPES.VIRTUAL
        ]
    },
    {
        name: 'Ranked Multiple Choice',
        type: types_2.INCA_VARIABLE_TYPES.RANKED_MULTI_CHOICE,
        supportedFunctionTypes: [
            types_2.INCA_VARIABLE_FUNCTION_TYPES.INCLUDES_WITH_RANK,
            types_2.INCA_VARIABLE_FUNCTION_TYPES.DOES_NOT_INCLUDE_RANK,
            types_2.INCA_VARIABLE_FUNCTION_TYPES.OPT_NUM_GREATER_THAN,
            types_2.INCA_VARIABLE_FUNCTION_TYPES.OPT_NUM_EQUALS_TO,
            types_2.INCA_VARIABLE_FUNCTION_TYPES.OPT_NUM_LESS_THAN,
            types_2.INCA_VARIABLE_FUNCTION_TYPES.IS_DISPLAYED,
            types_2.INCA_VARIABLE_FUNCTION_TYPES.IS_NOT_DISPLAYED
        ],
        supportedFormatterTypes: [
            types_2.INCA_VARIABLE_FORMATTER_TYPES.TYPE_FORMAT,
            types_2.INCA_VARIABLE_FORMATTER_TYPES.MULTI_OPTION_DISPLAY,
            types_2.INCA_VARIABLE_FORMATTER_TYPES.TEXT_CASING,
            types_2.INCA_VARIABLE_FORMATTER_TYPES.TEXT_TO_DISPLAY,
            types_2.INCA_VARIABLE_FORMATTER_TYPES.OTHER_TEXT
        ],
        availableQTypes: [types_1.QTYPES.RANK_ORDER]
    },
    {
        name: 'Open Ended Answers',
        type: types_2.INCA_VARIABLE_TYPES.OPEN,
        supportedFunctionTypes: [
            types_2.INCA_VARIABLE_FUNCTION_TYPES.STRING_CONTAINS,
            types_2.INCA_VARIABLE_FUNCTION_TYPES.STRING_DOES_NOT_CONTAIN,
            types_2.INCA_VARIABLE_FUNCTION_TYPES.STRING_EQUALS,
            types_2.INCA_VARIABLE_FUNCTION_TYPES.STRING_DOES_NOT_EQUAL,
            // INCA_VARIABLE_FUNCTION_TYPES.STRING_LIKE,
            // INCA_VARIABLE_FUNCTION_TYPES.STRING_MATCHES,
            types_2.INCA_VARIABLE_FUNCTION_TYPES.IS_DISPLAYED,
            types_2.INCA_VARIABLE_FUNCTION_TYPES.IS_NOT_DISPLAYED,
            types_2.INCA_VARIABLE_FUNCTION_TYPES.TARGETS_DETECTED,
            types_2.INCA_VARIABLE_FUNCTION_TYPES.TARGETS_NOT_DETECTED
        ],
        supportedFormatterTypes: [types_2.INCA_VARIABLE_FORMATTER_TYPES.TEXT_CASING],
        availableQTypes: [types_1.QTYPES.OPEN]
    },
    {
        name: 'Numeric Answers',
        type: types_2.INCA_VARIABLE_TYPES.NUMERIC,
        supportedFunctionTypes: [
            types_2.INCA_VARIABLE_FUNCTION_TYPES.INCLUDES,
            types_2.INCA_VARIABLE_FUNCTION_TYPES.DOES_NOT_INCLUDE,
            types_2.INCA_VARIABLE_FUNCTION_TYPES.NUM_GREATER_THAN,
            types_2.INCA_VARIABLE_FUNCTION_TYPES.NUM_GREATER_THAN_OR_EQUALS,
            types_2.INCA_VARIABLE_FUNCTION_TYPES.NUM_EQUALS_TO,
            types_2.INCA_VARIABLE_FUNCTION_TYPES.NUM_DOES_NOT_EQUAL,
            types_2.INCA_VARIABLE_FUNCTION_TYPES.NUM_LESS_THAN,
            types_2.INCA_VARIABLE_FUNCTION_TYPES.NUM_LESS_THAN_OR_EQUALS,
            types_2.INCA_VARIABLE_FUNCTION_TYPES.IS_DISPLAYED,
            types_2.INCA_VARIABLE_FUNCTION_TYPES.IS_NOT_DISPLAYED,
            types_2.INCA_VARIABLE_FUNCTION_TYPES.INCLUDES,
            types_2.INCA_VARIABLE_FUNCTION_TYPES.DOES_NOT_INCLUDE
        ],
        supportedFormatterTypes: [],
        availableQTypes: [types_1.QTYPES.NUMERIC]
    },
    {
        name: 'URL Metadata',
        type: types_2.INCA_VARIABLE_TYPES.URL_METADATA,
        supportedFunctionTypes: [
            types_2.INCA_VARIABLE_FUNCTION_TYPES.STRING_CONTAINS,
            types_2.INCA_VARIABLE_FUNCTION_TYPES.STRING_DOES_NOT_CONTAIN,
            types_2.INCA_VARIABLE_FUNCTION_TYPES.STRING_EQUALS,
            types_2.INCA_VARIABLE_FUNCTION_TYPES.STRING_DOES_NOT_EQUAL,
            // INCA_VARIABLE_FUNCTION_TYPES.STRING_LIKE,
            // INCA_VARIABLE_FUNCTION_TYPES.STRING_MATCHES,
            types_2.INCA_VARIABLE_FUNCTION_TYPES.NUM_GREATER_THAN,
            types_2.INCA_VARIABLE_FUNCTION_TYPES.NUM_GREATER_THAN_OR_EQUALS,
            types_2.INCA_VARIABLE_FUNCTION_TYPES.NUM_EQUALS_TO,
            types_2.INCA_VARIABLE_FUNCTION_TYPES.NUM_DOES_NOT_EQUAL,
            types_2.INCA_VARIABLE_FUNCTION_TYPES.NUM_LESS_THAN,
            types_2.INCA_VARIABLE_FUNCTION_TYPES.NUM_LESS_THAN_OR_EQUALS
        ],
        supportedFormatterTypes: [types_2.INCA_VARIABLE_FORMATTER_TYPES.TEXT_CASING],
        availableQTypes: [types_1.QTYPES.URL_METADATA]
    },
    {
        name: 'System Metadata',
        type: types_2.INCA_VARIABLE_TYPES.SYSTEM_METADATA,
        supportedFunctionTypes: [
            types_2.INCA_VARIABLE_FUNCTION_TYPES.INCLUDES,
            types_2.INCA_VARIABLE_FUNCTION_TYPES.DOES_NOT_INCLUDE
        ],
        supportedFormatterTypes: [types_2.INCA_VARIABLE_FORMATTER_TYPES.TEXT_CASING],
        availableQTypes: [
            types_1.QTYPES.LANGUAGE,
            types_1.QTYPES.DEVICE,
            types_1.QTYPES.SPECIALS,
            types_1.QTYPES.PANEL
        ]
    },
    {
        name: 'Baisc Question Logic',
        type: types_2.INCA_VARIABLE_TYPES.BASIC,
        supportedFunctionTypes: [
            types_2.INCA_VARIABLE_FUNCTION_TYPES.IS_DISPLAYED,
            types_2.INCA_VARIABLE_FUNCTION_TYPES.IS_NOT_DISPLAYED
        ],
        supportedFormatterTypes: [],
        availableQTypes: [
            types_1.QTYPES.MULTIMEDIA,
            types_1.QTYPES.VIDEO_ANNOTATION,
            types_1.QTYPES.TEXT_HIGHLIGHTER,
            types_1.QTYPES.GUIDED_FANTASY,
            types_1.QTYPES.JOURNEY,
            types_1.QTYPES.RAPID_CHOICE
        ]
    }
];
/**
 * Logical functions available for usage to evaluate inca variables in some manner.
 */
exports.IncaVariableFunctions = [
    {
        label: 'INCLUDES',
        type: types_2.INCA_VARIABLE_FUNCTION_TYPES.INCLUDES,
        args: 'options',
        function_pointer: 'includesOptions',
        value: 1
    },
    {
        label: 'does NOT INCLUDES',
        type: types_2.INCA_VARIABLE_FUNCTION_TYPES.DOES_NOT_INCLUDE,
        args: 'options',
        function_pointer: 'doesNotIncludeOption',
        value: 2
    },
    {
        label: 'INCLUDES',
        type: types_2.INCA_VARIABLE_FUNCTION_TYPES.INCLUDES_WITH_RANK,
        args: 'options',
        function_pointer: 'includesOptionsWithRank',
        value: 20
    },
    {
        label: 'does NOT INCLUDES',
        type: types_2.INCA_VARIABLE_FUNCTION_TYPES.DOES_NOT_INCLUDE_RANK,
        args: 'options',
        function_pointer: 'doesNotIncludeOptionWithRank',
        value: 21
    },
    {
        label: 'number of selected options GREATER than',
        type: types_2.INCA_VARIABLE_FUNCTION_TYPES.OPT_NUM_GREATER_THAN,
        args: 'number',
        function_pointer: 'greaterNumberOptions',
        value: 3
    },
    {
        label: 'number of selected options EQUALS to',
        type: types_2.INCA_VARIABLE_FUNCTION_TYPES.OPT_NUM_EQUALS_TO,
        args: 'number',
        function_pointer: 'equalNumberOptions',
        value: 4
    },
    {
        label: 'number of selected options LESS than',
        type: types_2.INCA_VARIABLE_FUNCTION_TYPES.OPT_NUM_LESS_THAN,
        args: 'number',
        function_pointer: 'lessNumberOptions',
        value: 5
    },
    {
        label: 'Contains [text]',
        type: types_2.INCA_VARIABLE_FUNCTION_TYPES.STRING_CONTAINS,
        args: 'string',
        function_pointer: 'stringContains',
        value: 6
    },
    {
        label: 'does not Contain [text]',
        type: types_2.INCA_VARIABLE_FUNCTION_TYPES.STRING_DOES_NOT_CONTAIN,
        args: 'string',
        function_pointer: 'stringDoesNotContain',
        value: 7
    },
    {
        label: 'Equals [text]',
        type: types_2.INCA_VARIABLE_FUNCTION_TYPES.STRING_EQUALS,
        args: 'string',
        function_pointer: 'stringEqauls',
        value: 8
    },
    {
        label: 'does not Equal [text]',
        type: types_2.INCA_VARIABLE_FUNCTION_TYPES.STRING_DOES_NOT_EQUAL,
        args: 'string',
        function_pointer: 'stringDoesNotEqual',
        value: 9
    },
    // @TODO Require NLP capability. Temporarily disabled
    // {
    //     label: 'LIKE [text]',
    //     type: INCA_VARIABLE_FUNCTION_TYPES.STRING_LIKE,
    //     args: 'string',
    //     function_pointer: 'likeText',
    //     value: 10
    // },
    // {
    //     label: 'MATCHES [text]',
    //     type: INCA_VARIABLE_FUNCTION_TYPES.STRING_MATCHES,
    //     args: 'regex',
    //     function_pointer: 'matchesRegex',
    //     value: 11
    // },
    {
        label: 'Greater than [numeric]',
        type: types_2.INCA_VARIABLE_FUNCTION_TYPES.NUM_GREATER_THAN,
        args: 'number',
        function_pointer: 'numericGreaterThan',
        value: 12
    },
    {
        label: 'Greater than OR Equals [numeric]',
        type: types_2.INCA_VARIABLE_FUNCTION_TYPES.NUM_GREATER_THAN_OR_EQUALS,
        args: 'number',
        function_pointer: 'numericGreaterThanOrEquals',
        value: 18
    },
    {
        label: 'Equals [numeric]',
        type: types_2.INCA_VARIABLE_FUNCTION_TYPES.NUM_EQUALS_TO,
        args: 'number',
        function_pointer: 'numericEquals',
        value: 13
    },
    {
        label: 'does not Equal [numeric]',
        type: types_2.INCA_VARIABLE_FUNCTION_TYPES.NUM_DOES_NOT_EQUAL,
        args: 'number',
        function_pointer: 'numericDoesNotEqual',
        value: 14
    },
    {
        label: 'Less than [numeric]',
        type: types_2.INCA_VARIABLE_FUNCTION_TYPES.NUM_LESS_THAN,
        args: 'number',
        function_pointer: 'numericLessThan',
        value: 15
    },
    {
        label: 'Less than OR Equals [numeric]',
        type: types_2.INCA_VARIABLE_FUNCTION_TYPES.NUM_LESS_THAN_OR_EQUALS,
        args: 'number',
        function_pointer: 'numericLessThanOrEquals',
        value: 19
    },
    {
        label: 'is Displayed',
        type: types_2.INCA_VARIABLE_FUNCTION_TYPES.IS_DISPLAYED,
        args: 'boolean',
        function_pointer: 'isDisplayed',
        value: 16
    },
    {
        label: 'is NOT Displayed',
        type: types_2.INCA_VARIABLE_FUNCTION_TYPES.IS_NOT_DISPLAYED,
        args: 'boolean',
        function_pointer: 'isNotDisplayed',
        value: 17
    },
    {
        label: 'target(s) detected [SmartProbe]',
        type: types_2.INCA_VARIABLE_FUNCTION_TYPES.TARGETS_DETECTED,
        args: 'targets',
        function_pointer: 'isTargetsDetected',
        value: 22
    },
    {
        label: 'target(s) not detected [SmartProbe]',
        type: types_2.INCA_VARIABLE_FUNCTION_TYPES.TARGETS_NOT_DETECTED,
        args: 'targets',
        function_pointer: 'isNotTargetsDetected',
        value: 23
    }
];
/**
 * Mapping of inca variable function values (unique numbers) to labels (human-readable strings).
 */
exports.IncaVariableFunctionsLabels = exports.IncaVariableFunctions.reduce(function (obj, curr) {
    var _a;
    return __assign(__assign({}, obj), (_a = {}, _a[curr.value] = curr.label, _a));
}, {});
/**
 * Formatters available for inca variables.
 */
exports.IncaVariableFormatters = [
    {
        label: 'Reference type format',
        value: types_2.INCA_VARIABLE_FORMATTER_TYPES.TYPE_FORMAT,
        supportedFormatterOptions: [
            {
                label: 'Text',
                value: types_2.INCA_VARIABLE_FORMATTER_OPTION_TYPES.TYPE_FORMAT_TEXT
            },
            {
                label: 'Image',
                value: types_2.INCA_VARIABLE_FORMATTER_OPTION_TYPES.TYPE_FORMAT_IMAGE
            }
        ]
    },
    {
        label: 'Text casing',
        value: types_2.INCA_VARIABLE_FORMATTER_TYPES.TEXT_CASING,
        supportedFormatterOptions: [
            {
                label: 'None',
                value: types_2.INCA_VARIABLE_FORMATTER_OPTION_TYPES.TEXT_CASING_NONE
            },
            {
                label: 'Uppercase first letter',
                value: types_2.INCA_VARIABLE_FORMATTER_OPTION_TYPES.TEXT_CASING_UPPER_FIRST
            },
            {
                label: 'Uppercase all',
                value: types_2.INCA_VARIABLE_FORMATTER_OPTION_TYPES.TEXT_CASING_UPPER_ALL
            },
            {
                label: 'Lowercase first letter',
                value: types_2.INCA_VARIABLE_FORMATTER_OPTION_TYPES.TEXT_CASING_LOWER_FIRST
            },
            {
                label: 'Lowercase all',
                value: types_2.INCA_VARIABLE_FORMATTER_OPTION_TYPES.TEXT_CASING_LOWER_ALL
            }
        ]
    },
    {
        label: 'Text to display',
        value: types_2.INCA_VARIABLE_FORMATTER_TYPES.TEXT_TO_DISPLAY,
        supportedFormatterOptions: [
            {
                label: 'Option Text',
                value: types_2.INCA_VARIABLE_FORMATTER_OPTION_TYPES.TEXT_TO_DISPLAY_TEXT
            },
            {
                label: 'Option Label',
                value: types_2.INCA_VARIABLE_FORMATTER_OPTION_TYPES.TEXT_TO_DISPLAY_LABEL
            }
        ]
    },
    {
        label: 'Multi-option display',
        value: types_2.INCA_VARIABLE_FORMATTER_TYPES.MULTI_OPTION_DISPLAY,
        supportedFormatterOptions: [
            {
                label: 'Ascending',
                value: types_2.INCA_VARIABLE_FORMATTER_OPTION_TYPES.MULTI_OPTION_DISPLAY_ASC
            },
            {
                label: 'Descending',
                value: types_2.INCA_VARIABLE_FORMATTER_OPTION_TYPES.MULTI_OPTION_DISPLAY_DESC
            },
            {
                label: 'Specific rank',
                value: types_2.INCA_VARIABLE_FORMATTER_OPTION_TYPES.MULTI_OPTION_DISPLAY_RANK
            }
        ]
    },
    {
        label: 'Other text',
        value: types_2.INCA_VARIABLE_FORMATTER_TYPES.OTHER_TEXT,
        supportedFormatterOptions: [
            {
                label: 'Other Text',
                value: types_2.INCA_VARIABLE_FORMATTER_OPTION_TYPES.OTHER_TEXT_TEXT
            },
            {
                label: 'Other label',
                value: types_2.INCA_VARIABLE_FORMATTER_OPTION_TYPES.OTHER_TEXT_LABEL
            },
            {
                label: 'Specify wording',
                value: types_2.INCA_VARIABLE_FORMATTER_OPTION_TYPES.OTHER_TEXT_SPECIFY
            }
        ]
    }
];
//# sourceMappingURL=constants.js.map